import React, { useEffect } from 'react'
import SearchFilters from './SearchFilters/SearchFilters'
import SearchResults from './SearchResults/SearchResults'
import styles from './styles.module.css'
import MapViewDr6 from '../mapViewDr6'

export default function BusinessDataDR15 () {
  const dataType = "business"

  useEffect(() => {
    localStorage.setItem('dfp/dataTypeNavigation', 'business')
    document.title = 'Datafiniti Portal | Business'
    window.scrollTo(0, 0)
  }, []) /* eslint-disable-line react-hooks/exhaustive-deps */
  
  return (
    <main className={styles.mainContainerBusiness}>
      <SearchFilters />
      <div className={styles.containerPropertyAndMap}>
        <div className={styles.searchResultContainerProperty}>
          <SearchResults />
        </div>
        <div className={styles.mapContainer}>
          <MapViewDr6 dataType={dataType} />
        </div>
      </div>
    </main>
  )
}
